// Profile spam reaction presentation mode (i.e. `spamReactionView`)
export const VERBOSE_REACT_VIEW = "VERBOSE";
export const CONCISE_REACT_VIEW = "CONCISE";
